import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

// @ts-ignore
import * as IScroll from 'iscroll';

const classes = {
	stateActive: 'state-m-breadcrumb__item--is-active',
	stateShowAll: 'state-m-breadcrumb--show-all',
	stateEllipsis: 'state-m-breadcrumb--show-ellipsis',
	flyoutOpener: 'js-m-breadcrumb__opener',
	flyout: 'js-m-breadcrumb__flyout',
	navItem: 'js-m-breadcrumb__item',
	scroller: 'js-m-breadcrumb__scroller',
	scrollerContent: 'js-m-breadcrumb__scroller-content',
	ellipsisToggle: 'js-m-breadcrumb__ellipsis-toggle',
};

let initialContentWidth = 0;
let breadcrumbScroll: IScroll;

@createModule('Breadcrumb')
/**
 * Breadcrumb module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class Breadcrumb extends TerrificSpec {
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		//adds event handler to open flyouts
		this.initBreadcrumbOpening($ctx);

		breadcrumbScroll = new IScroll(`.${classes.scroller}`, {
			mouseWheel: true,
			scrollbars: false,
			scrollX: true,
			scrollY: false,
		});

		initialContentWidth = $(`.${classes.scrollerContent}`, $ctx).innerWidth();

		this.setEllipsisWhenNotEnoughSpace($ctx);

		$(window).on('resize.BreadcrumbEllipsing', () => {
			this.setEllipsisWhenNotEnoughSpace($ctx);
		});

		resolve();
	}
	stop() {}

	initBreadcrumbOpening($ctx: JQuery) {
		const breadcrumbOpener = $(`.${classes.navItem}`, $ctx),
			ellipsisToggle = $(`.${classes.ellipsisToggle}`, $ctx);

		ellipsisToggle.on('click.EnterScrollMode', () => {
			$ctx.addClass(classes.stateShowAll);
			this.refreshScroll();
		});

		breadcrumbOpener.each((index, elem) => {
			let flyoutOpener = $(elem).find(`.${classes.flyoutOpener}`);
			flyoutOpener.on('click.OpenBreadcrumb', (event: Event) => {
				if (!$(elem).hasClass(classes.stateActive)) {
					this.openFlyoutAndDisableScrolling(elem, breadcrumbScroll, breadcrumbOpener);
				} else {
					this.closeAllFlyoutsAndReenableScrolling(breadcrumbScroll, breadcrumbOpener);
				}

				this.refreshScroll();
				event.preventDefault();
				event.stopPropagation();
			});

			// needed to not trigger touchend on body on mobile devices when flyoutOpener is hit to prevent toggle off/on effect and closing when inner touch-scrolling ends
			$(elem).on('touchend.OpenBreadCrumb', (event: Event) => {
				if ($(elem).hasClass(classes.stateActive)) {
					event.stopPropagation();
				}
			});
		});

		$('body').on('click.closeBreadCrumb touchend.closeBreadCrumb', () => {
			this.closeAllFlyoutsAndReenableScrolling(breadcrumbScroll, breadcrumbOpener);
		});
	}

	openFlyoutAndDisableScrolling(flyoutElement: HTMLElement, breadcrumbScroll: IScroll, breadcrumbOpener: JQuery) {
		breadcrumbScroll.disable();
		breadcrumbOpener.removeClass(classes.stateActive);
		$(flyoutElement).addClass(classes.stateActive);
		breadcrumbScroll.refresh();
		this.autoScrollIfOutOfScreen(flyoutElement);
	}

	autoScrollIfOutOfScreen(flyoutElement: HTMLElement) {
		const flyoutLeft = $(flyoutElement)
			.find(`.${classes.flyout}`)
			.offset().left;
		const flyoutWidth = $(flyoutElement)
			.find(`.${classes.flyout}`)
			.width();
		const offset = 10;

		if (flyoutLeft < offset) {
			breadcrumbScroll.scrollToElement(flyoutElement, 300, -1 * offset);
		} else if (flyoutLeft >= offset && flyoutLeft + flyoutWidth + offset > $('body').width()) {
			breadcrumbScroll.scrollToElement(flyoutElement, 300, offset - ($('body').width() - flyoutWidth));
		}
	}

	closeAllFlyoutsAndReenableScrolling(breadcrumbScroll: IScroll, breadcrumbOpener: JQuery) {
		breadcrumbScroll.enable();
		breadcrumbOpener.removeClass(classes.stateActive);
	}

	setEllipsisWhenNotEnoughSpace($ctx: JQuery) {
		const isNotEnoughSpace = $(`.${classes.scroller}`, $ctx).outerWidth() < initialContentWidth;
		$ctx.toggleClass(classes.stateEllipsis, isNotEnoughSpace);
		this.refreshScroll();
	}

	refreshScroll() {
		setTimeout(() => {
			breadcrumbScroll.refresh();
		}, 0);
	}
}
